import React from "react";
import { stats } from "../mock";

const Stats = () => {
  return (
    <section className="relative py-16 lg:py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {stats.map((s, i) => (
            <div
              key={i}
              className="group relative p-6 lg:p-8 bg-white rounded-2xl border border-[#ead8c9] hover:border-sterling transition-all hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(138,93,72,0.25)]"
            >
              <div className="font-serif-display text-5xl lg:text-6xl text-ink">
                {s.value}
              </div>
              <div className="mt-2 text-sm uppercase tracking-[0.2em] text-[#daae9c]">
                {s.label}
              </div>
              <div className="absolute top-6 right-6 w-2 h-2 rounded-full bg-sterling opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
